import { useState, useEffect } from "react";
import { useApp, api } from "../../context";
import { Shell } from "../../components";

export default function SoloPlayPage() {
  const { c, dark, go } = useApp();
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api("/solo/state").then(r => {
      if (r.ok) setState(r.data);
      setLoading(false);
    });
  }, []);

  const GAMES = [
    {
      id: "ball_sort",
      icon: "🎨",
      title: "Ball Sort",
      desc: "Sort colored balls into tubes. Race against the clock and earn GT tokens!",
      color: "#6c5ce7",
      available: true,
    },
    {
      id: "trivia_solo",
      icon: "🧠",
      title: "Solo Trivia",
      desc: "Answer questions alone. Earn GT tokens for every correct answer!",
      color: "#e91e8c",
      available: false,
    },
    {
      id: "word_puzzle",
      icon: "📝",
      title: "Word Puzzle",
      desc: "Unscramble spicy words and phrases. How fast can you go?",
      color: "#f59e0b",
      available: false,
    },
    {
      id: "memory_match",
      icon: "🃏",
      title: "Memory Match",
      desc: "Flip cards and find matching pairs. Train your memory!",
      color: "#10b981",
      available: false,
    },
  ];

  const LivesDisplay = () => {
    if (!state) return null;
    const lives = state.lives || 0;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {[1,2,3].map(i => (
          <span key={i} style={{ fontSize: 18, filter: i <= lives ? "none" : "grayscale(1) opacity(0.3)" }}>❤️</span>
        ))}
        {lives < 3 && state.life_refill_at && (
          <span style={{ fontSize: 10, color: c.faint, marginLeft: 4 }}>refills soon</span>
        )}
      </div>
    );
  };

  return (
    <Shell title="Solo Play" showBack onBack={() => go("games")}>
      <div style={{ padding: "12px 0" }}>

        {/* Stats bar */}
        {!loading && state && (
          <div style={{ background: dark ? "#1a1040" : "#f0edff", borderRadius: 14, padding: "14px 16px", marginBottom: 16, border: "1px solid #6c5ce720" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: c.text }}>Your Progress</div>
              <div style={{ fontSize: 11, color: "#6c5ce7", fontWeight: 700 }}>Level {state.level}</div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <LivesDisplay />
              <div style={{ fontSize: 11, color: c.faint }}>
                🪙 {state.gt_earned_today}/{state.gt_daily_cap} GT today
              </div>
              <div style={{ fontSize: 11, color: "#f59e0b", fontWeight: 700 }}>
                🔥 {state.streak} streak
              </div>
            </div>
          </div>
        )}

        {/* Game cards */}
        <div style={{ fontSize: 11, fontWeight: 700, color: c.faint, marginBottom: 10, textTransform: "uppercase", letterSpacing: 1 }}>
          Choose a Game
        </div>

        {GAMES.map(game => (
          <div key={game.id} onClick={() => game.available && go("ball_sort")}
            style={{ background: c.card, borderRadius: 16, border: `1px solid ${game.available ? game.color + "30" : c.border}`, padding: "16px", marginBottom: 10, cursor: game.available ? "pointer" : "default", opacity: game.available ? 1 : 0.6, position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg,${game.color},${game.color}00)` }} />
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <div style={{ width: 52, height: 52, borderRadius: 14, background: game.color + "20", border: `1px solid ${game.color}30`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0 }}>
                {game.icon}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 15, fontWeight: 800, color: c.text }}>{game.title}</span>
                  {!game.available && <span style={{ fontSize: 9, fontWeight: 700, color: "#888", background: "#88888820", padding: "2px 8px", borderRadius: 20 }}>Coming Soon</span>}
                  {game.available && state && <span style={{ fontSize: 9, fontWeight: 700, color: game.color, background: game.color + "20", padding: "2px 8px", borderRadius: 20 }}>Level {state.level}</span>}
                </div>
                <div style={{ fontSize: 12, color: c.sub, lineHeight: 1.5 }}>{game.desc}</div>
              </div>
              {game.available && <span style={{ fontSize: 20, color: c.faint }}>›</span>}
            </div>
          </div>
        ))}

        {/* Leaderboard teaser */}
        <div style={{ background: dark ? "#1a1a0a" : "#fffbeb", border: "1px solid #f59e0b30", borderRadius: 14, padding: "14px 16px", marginTop: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#f59e0b", marginBottom: 4 }}>🏆 Solo Leaderboard</div>
          <div style={{ fontSize: 12, color: c.sub }}>Reach the highest level to top the leaderboard and earn bonus GT tokens!</div>
        </div>

        <div style={{ height: 80 }} />
      </div>
    </Shell>
  );
}